<template>
  <view
    class="info-btn w-42px h-42px fixed bottom-140px right-10px flex justify-center items-center"
    @click="goKf"
  >
    <img class="w-28px h-28px" src="@/static/images/icon/kf.png" alt="" />
  </view>
</template>

<script setup lang="ts">
import { useUserStore } from '@/store'
import { storeToRefs } from 'pinia'
import { onLineService } from '@/utils'
const userStore = useUserStore()
const { userInfo } = storeToRefs(userStore)
const goKf = () => {
  onLineService()
}
</script>

<style scoped lang="scss">
.info-btn {
  z-index: 999;
  cursor: pointer;
  transition: all 0.3s ease;

  // 按钮主体 - 使用 ::after 创建
  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 8px;
    font-size: 12px;
    font-weight: 700;
    color: white;
    content: attr(data-text);
    background: linear-gradient(135deg, #0c5eff 0%, #1398f9 100%);
    border-radius: 6px;
    box-shadow:
      0 3px 28px rgba(34, 131, 246, 0.4),
      inset 0 3px 3px hsla(0, 0%, 100%, 0.3);
    transition: all 0.3s ease;
  }

  // 按钮阴影 - 使用 ::before 创建
  &::before {
    position: absolute;
    top: 3px;
    right: 0;
    bottom: -3px;
    left: 0;
    z-index: 1;
    content: '';
    background: #003293;
    border-radius: 6px;
    transition: all 0.3s ease;
  }

  // 图标样式
  img {
    position: relative;
    z-index: 3;
    filter: brightness(1.1);
    transition: transform 0.2s ease;
  }

  // 悬停效果
  &:hover {
    transform: translateY(-2px);

    &::after {
      box-shadow:
        0 6px 35px rgba(34, 131, 246, 0.5),
        inset 0 3px 3px hsla(0, 0%, 100%, 0.4);
    }

    &::before {
      transform: translateY(2px);
    }

    img {
      transform: scale(1.1);
    }
  }

  // 点击效果
  &:active {
    transform: translateY(0);

    &::after {
      box-shadow:
        0 2px 15px rgba(34, 131, 246, 0.3),
        inset 0 3px 3px hsla(0, 0%, 100%, 0.2);
    }

    &::before {
      transform: translateY(0);
    }

    img {
      transform: scale(0.95);
    }
  }
}

// 暗色主题适配
:deep(.dark) {
  .info-btn {
    &::after {
      background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);
      box-shadow:
        0 3px 28px rgba(30, 64, 175, 0.4),
        inset 0 3px 3px hsla(0, 0%, 100%, 0.2);
    }

    &::before {
      background: #1e3a8a;
    }

    &:hover::after {
      box-shadow:
        0 6px 35px rgba(30, 64, 175, 0.5),
        inset 0 3px 3px hsla(0, 0%, 100%, 0.3);
    }
  }
}
</style>
